"use strict";
exports.__esModule = true;
var errorCodeSummary = new Map();
var errorIdentifierSummary = new Map();
var featureUsageCount = new Map();
var _mapToObj = function (strMap) {
    var obj = Object.create(null);
    strMap.forEach(function (value, key) { return (obj[key] = value); });
    return obj;
};
exports.TrackError = function (identifier, errorCode) {
    var prevIdentifierCount = errorIdentifierSummary.get(identifier);
    if (prevIdentifierCount) {
        errorIdentifierSummary.set(identifier, ++prevIdentifierCount);
    }
    else {
        errorIdentifierSummary.set(identifier, 1);
    }
    if (errorCode) {
        var prevCodeCount = errorCodeSummary.get(errorCode);
        if (prevCodeCount) {
            errorCodeSummary.set(errorCode, ++prevCodeCount);
        }
        else {
            errorCodeSummary.set(errorCode, 1);
        }
    }
};
exports.TrackFeatureUsage = function (featureName) {
    var prevCount = featureUsageCount.get(featureName);
    if (prevCount) {
        featureUsageCount.set(featureName, ++prevCount);
    }
    else {
        featureUsageCount.set(featureName, 1);
    }
};
exports.GetForEvent = function () {
    var errorIdentifierObj = Object.create(null);
    var totalErrorCount = 0;
    errorIdentifierSummary.forEach(function (value, key) { return ((errorIdentifierObj[key] = value), (totalErrorCount += value)); });
    return {
        totalErrorCount: totalErrorCount,
        errorCodes: _mapToObj(errorCodeSummary),
        errorIdentifiers: errorIdentifierObj,
        featureUsage: _mapToObj(featureUsageCount)
    };
};
exports.ClearAll = function () {
    errorCodeSummary.clear();
    errorIdentifierSummary.clear();
    featureUsageCount.clear();
};
//# sourceMappingURL=ActiveSessionSummaries.js.map